const categories = state => state.categories;
const exams = state => state.exams;
const user = state => state.user;
const isLoadingExam = state => state.isLoadingExam;
const transactions = state => state.transactions;
const deposits = state => state.deposits;
const isLoadingTransaction = state => state.isLoadingTransaction;
const cityList = state => state.cityList;
const wardList = state => state.wardList;
const isLoadingCOD = state => state.isLoadingCOD;
const codMessage = state => state.codMessage;
const codStatus = state => state.codStatus;

export default {
  categories,
  exams,
  user,
  isLoadingExam,
  transactions,
  deposits,
  isLoadingTransaction,
  cityList,
  wardList,
  isLoadingCOD,
  codMessage,
  codStatus
};